import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { FaFilePdf } from "react-icons/fa";
import { Checkbox, Table } from "rsuite";
const { Column, HeaderCell, Cell, ColumnGroup } = Table;

const getCreditNoteAmount = (creditNote) =>
  Number(creditNote?.amount ?? creditNote?.requested_amount) || 0;

const isActiveCreditNote = (creditNote) =>
  creditNote && !["error", "unauthorized"].includes(creditNote.status);

function BillingTable({ data }) {
  const [billingData, setBillingData] = useState([]);

  useEffect(() => {
    const invoiceAmount = data?.invoice_id?.amount || 0;
    const commissionAmount = data?.invoice_dador_comision?.amount || 0;
    const isCommissionNotRequired = Boolean(
      data?.invoice_id?.invoice_dador_comision_not_required
    );
    let runningBalance = invoiceAmount;

    const commissionRow = data?.invoice_dador_comision?._id
      ? (() => {
          runningBalance += commissionAmount;
          return {
            invoice_date: data?.invoice_dador_comision?.date,
            invoice_number: data?.invoice_dador_comision?.number,
            amount: commissionAmount,
            saldo: runningBalance,
            pdf_url: data?.invoice_dador_comision?.pdf_url,
            comprobante: "Factura comision",
          };
        })()
      : isCommissionNotRequired
      ? {
          invoice_date: data?.invoice_id?.invoice_date,
          invoice_number: "No aplica",
          amount: 0,
          saldo: runningBalance,
          comprobante: "Comision",
        }
      : null;

    const movements = [
      ...(data?.invoice_id?.credit_notes || [])
        .filter(isActiveCreditNote)
        .map((creditNote) => ({
          invoice_date: creditNote.date || creditNote.createdAt,
          invoice_number: creditNote.number || "Pendiente",
          amount: -getCreditNoteAmount(creditNote),
          pdf_url: creditNote.pdf_url,
          comprobante: "Nota de credito",
        })),
      ...(data?.invoice_id?.receipts || []).map((receipt) => ({
        ...receipt,
        amount: -receipt.receipt_amount,
        comprobante: "Recibo",
      })),
    ].sort((a, b) => {
      const dateA = moment(a.invoice_date || a.receipt_date).valueOf();
      const dateB = moment(b.invoice_date || b.receipt_date).valueOf();
      return dateA - dateB;
    });

    const formattedBillingData = [
      {
        invoice_date: data?.invoice_id?.invoice_date,
        invoice_number: data?.invoice_id?.invoice_number,
        amount: invoiceAmount,
        saldo: invoiceAmount,
        pdf_url: data?.invoice_id?.pdf_url,
        comprobante: "Factura",
      },
      ...(commissionRow ? [commissionRow] : []),
      ...movements.map((movement) => {
        runningBalance += movement.amount;
        return {
          ...movement,
          saldo: runningBalance,
        };
      }),
    ];

    setBillingData(formattedBillingData);
  }, [data]);

  return (
    <Row className="mt-4">
      <Col md="12">
        <Table
          height={550}
          bordered
          cellBordered
          wordWrap={true}
          data={billingData}
        >
          <Column flexGrow={1} align="center">
            <HeaderCell>Fecha</HeaderCell>
            <Cell dataKey="fecha">
              {(rowData) => (
                <p>
                  {moment
                    .utc(rowData.invoice_date || rowData.receipt_date)
                    .format("DD/MM/YYYY")}
                </p>
              )}
            </Cell>
          </Column>
          <Column flexGrow={1} align="center">
            <HeaderCell>Comprobante</HeaderCell>
            <Cell dataKey="comprobante">
              {(rowData) => (
                <p>{rowData.comprobante || (rowData.invoice_date ? "Factura" : "Recibo")}</p>
              )}
            </Cell>
          </Column>
          <Column flexGrow={1} align="right">
            <HeaderCell>Nro de Comprobantes</HeaderCell>
            <Cell dataKey="nroComprobante">
              {(rowData) => {
                return (
                  <p>
                    {rowData.pdf_url && (
                      <a
                        href={rowData.pdf_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Ver PDF"
                      >
                        <FaFilePdf
                          className="mb-2 mr-2"
                          color="primary"
                          size={18}
                        />
                      </a>
                    )}
                    {rowData.invoice_number || rowData.receipt_number}
                  </p>
                );
              }}
            </Cell>
          </Column>
          <Column flexGrow={1} align="right">
            <HeaderCell>Importe</HeaderCell>
            <Cell dataKey="importe">
              {(rowData) => (
                <p>
                  {" "}
                  <CurrencyFormat
                    value={rowData.amount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                  />
                </p>
              )}
            </Cell>
          </Column>
          <Column flexGrow={1} align="right">
            <HeaderCell align="middle">Saldo</HeaderCell>
            <Cell dataKey="saldo">
              {(rowData) => (
                <p>
                  {" "}
                  <CurrencyFormat
                    value={rowData.saldo}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={"$"}
                  />
                </p>
              )}
            </Cell>
          </Column>
        </Table>
      </Col>
    </Row>
  );
}

export default BillingTable;
